"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var bluebird_1 = __importDefault(require("bluebird"));

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");

var ModifyTokenholderData_1 = require("./ModifyTokenholderData");

var constants_1 = require("../utils/constants");
/**
 * @hidden
 */


exports.createRefreshSecurityTokenFactoryResolver = function (factories, securityTokenId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(securityTokenId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that issues tokens to the specified addresses. KYC data for those addresses must already exist or otherwise be provided in this procedure
 */


var IssueTokens =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(IssueTokens, _Procedure_1$Procedur);

  function IssueTokens() {
    var _this2;

    _classCallCheck(this, IssueTokens);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(IssueTokens).apply(this, arguments));
    _this2.type = types_1.ProcedureType.IssueTokens;
    return _this2;
  }
  /**
   * Issue the specified amounts to the corresponding addresses
   * If KYC data is provided, transfer restrictions will not be checked before submitting the issuing transaction
   * This means that if one of the wallets on the list doesn't clear transfer restrictions, the transaction will revert
   *
   * Note that this procedure will fail if:
   * - The Security Token doesn't exist
   * - At least one wallet address doesn't clear transfer restrictions. This check is bypassed if new KYC data is provided
   */


  _createClass(IssueTokens, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var _this$args, symbol, issuanceData, _this$context, contractWrappers, factories, securityToken, investors, values, updatedTokenholderData, invalidAddresses, invalidCodes, securityTokenEntity, securityTokenId, _ref3, _ref4, newTokenholders;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, issuanceData = _this$args.issuanceData;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                _context4.prev = 2;
                _context4.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                investors = [];
                values = [];
                updatedTokenholderData = [];
                issuanceData.forEach(function (_ref) {
                  var address = _ref.address,
                      amount = _ref.amount,
                      tokenholderData = _ref.tokenholderData;
                  investors.push(address);
                  values.push(amount);

                  if (tokenholderData) {
                    updatedTokenholderData.push(Object.assign({
                      address: address
                    }, tokenholderData));
                  }
                });

                if (!(updatedTokenholderData.length > 0)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 18;
                return this.addProcedure(ModifyTokenholderData_1.ModifyTokenholderData)({
                  symbol: symbol,
                  tokenholderData: updatedTokenholderData
                });

              case 18:
                _context4.next = 26;
                break;

              case 20:
                invalidAddresses = [];
                invalidCodes = [];
                _context4.next = 24;
                return bluebird_1.default.map(investors, function (to, i) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2() {
                    var _ref2, statusCode;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return securityToken.canTransferFrom({
                              from: constants_1.ZERO_ADDRESS,
                              to: to,
                              value: values[i]
                            });

                          case 2:
                            _ref2 = _context2.sent;
                            statusCode = _ref2.statusCode;

                            if (statusCode !== contract_wrappers_1.TransferStatusCode.TransferSuccess) {
                              invalidAddresses.push(to);
                              invalidCodes.push(statusCode);
                            }

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });

              case 24:
                if (!invalidAddresses.length) {
                  _context4.next = 26;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot issue tokens to the following addresses: [".concat(invalidAddresses.join(', '), "]. Reasons: [").concat(invalidCodes.join(', '), "]")
                });

              case 26:
                _context4.next = 28;
                return factories.securityTokenFactory.fetch(entities_1.SecurityToken.generateId({
                  symbol: symbol
                }));

              case 28:
                securityTokenEntity = _context4.sent;
                securityTokenId = securityTokenEntity.uid;
                _context4.next = 32;
                return this.addTransaction(securityToken.issueMulti, {
                  tag: types_1.PolyTransactionTag.IssueMulti,
                  resolvers: [function () {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3() {
                      var fetchingTokenholders;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              fetchingTokenholders = investors.map(function (address) {
                                return factories.tokenholderFactory.fetch(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: address
                                }));
                              });
                              return _context3.abrupt("return", Promise.all(fetchingTokenholders));

                            case 2:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));
                  }, exports.createRefreshSecurityTokenFactoryResolver(factories, securityTokenId)]
                })({
                  investors: investors,
                  values: values
                });

              case 32:
                _ref3 = _context4.sent;
                _ref4 = _slicedToArray(_ref3, 1);
                newTokenholders = _ref4[0];
                return _context4.abrupt("return", newTokenholders);

              case 36:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));
    }
  }]);

  return IssueTokens;
}(Procedure_1.Procedure);

exports.IssueTokens = IssueTokens;